import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import CareerHero from '../components/CareerHero';
import WhatWeOffer from '../components/WhatWeOffer';
import IndustriesWeServe from '../components/IndustriesWeServe';

const Home = () => {
  return (
    <div>
      <Hero />
      <CareerHero />
      <WhatWeOffer />
      <Services />
      <IndustriesWeServe />
    </div>
  );
};

export default Home;